import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, e) {
  return o(), l("svg", t, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.46 6.59C3.213 4.592 4.649 2 7.006 2h10.748c2.367 0 3.802 2.613 2.53 4.61l-4.887 7.681v5.237c0 3.166-4.267 4.173-5.683 1.342a3 3 0 0 1-.317-1.342V14.32l-2.343-3.28-2.015-3.528z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: n };
export {
  i as default,
  n as render
};
//# sourceMappingURL=ic_filter_filled-C5ukhj62.js.map
